export const UPDATE_QUEUE_FILTER = 'UPDATE_QUEUE_FILTER'

export const SITEMAP_PARSE_SUCCESS = 'SITEMAP_PARSE_SUCCESS'
export const SITEMAP_PARSE_ERROR = 'SITEMAP_PARSE_ERROR'

export const LINKS_WARM_SUCCESS = 'LINKS_WARM_SUCCESS'
export const LINKS_WARM_ERROR = 'LINKS_WARM_ERROR'

export const LOAD_LINKS_SUCCESS = 'LOAD_LINKS_SUCCESS'
export const ADD_LINK_SUCCESS = 'ADD_LINK_SUCCESS'
export const CHANGE_LINK_SUCCESS = 'CHANGE_LINK_SUCCESS'
export const EMPTY_LINKS_LIST = 'EMPTY_LINKS_LIST'

export const UPDATE_LINKS_SORTING = 'UPDATE_LINKS_SORTING'



// WEBPACK FOOTER //
// ./src/modules/links/action-types.js